export function language() {
  const userLanguage = localStorage.getItem('user_language')
  const browserLanguage = navigator.language

  return userLanguage ?? browserLanguage
}

export function setLanguage(value) {
  localStorage.setItem('user_language', value)
}
